import React from "react";
import { Chip } from "@mui/material";

// DEV-1426 - Sub Order (channel pembuatan order terakhir) dari Lavender profile-customer
// (`lastOrder.sub_order`). Dipakai kartu Last Order Info (CustomerProfile) & Order Terakhir
// (CrmLiveChat/CustomerContextPanel) supaya label & warnanya selalu sama.
export const SUB_ORDER = {
    MANUAL_SAKURA: "Manual Sakura",
    ORDER_LINK: "Order Link",
    PRODUCT_CATALOG: "Katalog Produk",
    NOT_AVAILABLE: "Tidak Tersedia",
};

// Warna soft (bukan default MUI) supaya tetap senada dengan palet Live Chat (D-8 DEV-1049):
// Manual Sakura oranye, Order Link biru, Katalog Produk ungu, Tidak Tersedia abu-abu.
const SUB_ORDER_COLORS = {
    [SUB_ORDER.MANUAL_SAKURA]: { color: "#a85a14", backgroundColor: "#fbeadb" },
    [SUB_ORDER.ORDER_LINK]: { color: "#3f5f8f", backgroundColor: "#e3eaf5" },
    [SUB_ORDER.PRODUCT_CATALOG]: { color: "#6e4a8e", backgroundColor: "#eee5f5" },
    [SUB_ORDER.NOT_AVAILABLE]: { color: "#5f6368", backgroundColor: "#eceff1" },
};

// Nilai kosong / di luar 4 label yang dikenal (mis. BE lama belum kirim sub_order) -> "Tidak Tersedia".
export function resolveSubOrderLabel(subOrder) {
    return Object.prototype.hasOwnProperty.call(SUB_ORDER_COLORS, subOrder) ? subOrder : SUB_ORDER.NOT_AVAILABLE;
}

export function getSubOrderColors(subOrder) {
    return SUB_ORDER_COLORS[resolveSubOrderLabel(subOrder)];
}

export default function SubOrderChip({ subOrder }) {
    const label = resolveSubOrderLabel(subOrder);
    return (
        // component="span": di Live Chat chip dirender di dalam <Typography> (<p>) milik Row.
        <Chip
            component="span"
            size="small"
            label={label}
            data-testid="sub-order-chip"
            sx={{ ...getSubOrderColors(label), fontWeight: 600, fontSize: 12 }}
        />
    );
}
